export default __webpack_public_path__ + "assets/images/1.93a94a.png";